import { ChatFooter } from "../types/chat-footer";

export const chatFooterFallback: ChatFooter = {
  styles: {
    background: 'white',
    position: 'relative',
    borderBottomLeftRadius : '10px',
    borderBottomRightRadius : '10px',
  },

  inputGroup: {
    styles: {
      padding: '15px 15px',
      border: '1px solid #EBEBEB',
      display: 'flex' ,
      gap: '20px',
      borderRadius: '10px',
    },

    input: {
      styles: {
        flex: '1 1 auto',

        outline: 'none !important',
        border: 'none',
        borderRadius: '10px',
      },
      placeholder: 'Ask anything...'
    },

    sendButton: {
      styles: {
        width: '20px',
        height: '20px',
        
        padding: '0',
        border: 'none',
        background: 'none',
        cursor: 'pointer'
      },

      icon: {
        styles: {
        },
        src: '/assets/send-message-icon.svg'
      }
    },
  },

  footnotes: {
    styles: {
      margin: '0',
      padding: '15px 20px',
      fontSize: '10px',
      color: 'rgb(117, 117, 117)',
      fontFamily: 'Poppins, sans-serif',
      lineHeight: '18px'
    },
    innerHtml: '',
  },
  actionButtons: {
    color: 'black',
    backgroundColor: '#FFFFFF'
  }
};